import type { ReactNode } from 'react';
import { Icon, PopItem, Popover } from '../ui/kit';
import { ROLE_NAMES, useSession } from '../auth/session';
import { businessColor, initial } from './companies';
import { PRACTICE_ROLE_NAMES } from '../pages/practice/data';

/**
 * The switcher (PRACTICE-DESIGN.md 4): the person's practices on top, then their own companies.
 * Client companies are not listed; they are reached through Clients or Find a client.
 */
export function SwitcherPopover({ anchor, onClose, currentPractice, currentCompany, onPractice, onCompany, extra }: {
  anchor: HTMLElement; onClose: () => void; currentPractice?: string | undefined; currentCompany?: string | undefined;
  onPractice: (id: string, name: string) => void; onCompany: (id: string, name: string) => void; extra?: ReactNode;
}) {
  const session = useSession();
  return (
    <Popover anchor={anchor} onClose={onClose} label="Switch practice or company">
      {session.practices.length > 0 && <div className="pop-title">Practice</div>}
      {session.practices.map((p) => (
        <PopItem key={p.id} checked={p.id === currentPractice} onClick={() => { onClose(); if (p.id !== currentPractice) onPractice(p.id, p.name); }}
          lead={<span className="tenant-avatar practice-tile" style={{ background: businessColor(p.id) }} aria-hidden="true">{initial(p.name)}</span>}
          title={`${p.name} · Practice`} sub={p.role === 'partner' ? undefined : PRACTICE_ROLE_NAMES[p.role]} extra={p.id === currentPractice ? <Icon name="check" /> : undefined} />
      ))}
      {session.practices.length > 0 && session.tenants.length > 0 && <div className="pop-sep" />}
      {session.tenants.length > 0 && <div className="pop-title">Your companies</div>}
      {session.tenants.map((t) => (
        <PopItem key={t.id} checked={t.id === currentCompany} onClick={() => { onClose(); if (t.id !== currentCompany) onCompany(t.id, t.name); }}
          lead={<span className="tenant-avatar" style={{ background: businessColor(t.id) }} aria-hidden="true">{initial(t.name)}</span>}
          title={t.name} sub={t.role === 'owner' ? undefined : ROLE_NAMES[t.role]} extra={t.id === currentCompany ? <Icon name="check" /> : undefined} />
      ))}
      {extra}
    </Popover>
  );
}
